import { Controller } from "@hotwired/stimulus";

export default class LinkController extends Controller {

    navigate(event) {
        // access the post description link without open the show page
        if (event.target.closest("a")) {
            return;
        }

        if (event.target.closest('.inner-link')) {
            return;
        }

        event.preventDefault();

        const href = this.element.getAttribute("href");
        if (href) {
            Turbo.visit(href);
        }
    }


}